import { useState } from 'react'

import type Highcharts from 'highcharts/highstock'

const useHighchartsRef = (): {
  handleSetHighchartsRef: (highchartsRef: typeof Highcharts) => void
  highcharts?: typeof Highcharts
} => {
  const [highcharts, setHighchartsRef] = useState<typeof Highcharts>()

  const handleSetHighchartsRef = (highchartsRef: typeof Highcharts) => {
    setHighchartsRef(highchartsRef)
  }

  return { handleSetHighchartsRef, highcharts }
}

export { useHighchartsRef }
